import React from "react";
import ReactECharts from "echarts-for-react";
import { Empty, Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";

interface StatusItem {
  status: string;
  count: number;
}

interface PhaseStatusChartProps {
  loading: boolean;
  data: StatusItem[] | null;
}

const statusColors: Record<string, string> = {
  Draft: "#5170D7",
  Pending: "#69C86F",
  Active: "#F8C451",
  OnHold: "#E06666",
  Closed: "#69C0FF",
  Archived: "#48C9B0",
  InProgress: "#BA68C8",
};

const PhaseStatusChart: React.FC<PhaseStatusChartProps> = ({ loading, data }) => {
  const getOption = () => ({
    tooltip: {
      trigger: "item",
      formatter: "{b}: {c} ({d}%)",
    },
    legend: {
      orient: "vertical",
      left: "right",
      top: "middle",
    },
    series: [
      {
        name: "Phase Status",
        type: "pie",
        radius: "65%",
        center: ["45%", "50%"],
        data: data?.map((item) => ({
          value: item.count,
          name: item.status,
          itemStyle: {
            color: statusColors[item.status] || "#d9d9d9",
          },
        })),
        label: {
          formatter: "{b}\n{d}%",
        },
      },
    ],
  });

  return (
    <>
      {loading ? (
        <div style={{ height: 220, display: "flex", alignItems: "center", justifyContent: "center" }}>
          <Spin indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />} />
        </div>
      ) : !data || data.length === 0 ? (
        <div style={{ height: 220, display: "flex", alignItems: "center", justifyContent: "center" }}>
          <Empty description="No data found" />
        </div>
      ) : (
        <ReactECharts
          option={getOption()}
          style={{ height: 300, width: "100%" }}
          notMerge={true}
          lazyUpdate={true}
        />
      )}
    </>
  );
};

export default PhaseStatusChart;
